import ta_launcher from "./http_launcher_producer";

/**File to represent the pg namespace */
export default class PG {
  static centralNewHost = {
    //protocol - > ftp://, http://, https://
    protocol: "",
    //IP -> 256.256.256.256
    ip: document.location.hostname,
    //PORT -> 8080
    port: "",
    //nodeID - > 1485858158858
    nodeID: 0,
    //authorization encoded
    credentials: "",
  };

  static available = {
    statusViaGet: undefined,
    serviceStatus: undefined,
  };

  /**
   * A malleable object storing a number of quasi-global (within the PG namespace
   * but publicly accessible) flags and application states
   *
   * @type {object}
   * @memberOf pg
   * @property {integer} detectRequests - stores a count of requests made by pg.rest.connect
   * @property {integer} confirmAttempts - stores a count of number of times a 'confirm' dialog has appeared
   */
  static state = {
    detectRequests: 0,
    confirmAttempts: 0,
    validCreds: null,
    pollHeartbeat: true,
    dontThrowConnectionError: false,
    lastErrorConnectionMessage: "",
    requestingConnection: false,
    //added this flag to avoid pg.init.remoteFiles() been called twice (provoking two connection request)
    remoteFilesIntialRequest: false,
    //added this flag to avoid pg.init.localFiles() been called twice (provoking two connection request)
    localFilesIntialRequest: false,
    // REST CALL rs/agent/serviceStatus -> serviceRunning save info. (default false)
    isRunningAsService: false,
    currentVersion: 0,
    applicationLaunched: false,
  };

  static localConfig = {
    declineUpgrade: undefined,
  };

  static version = "3.8.5 3 85";

  static dialog = {
    hooks: {
      upgrade: undefined,
      launch: undefined,
      launchFailed: undefined,
    },
  };

  static clearModals = () => {
    Object.entries(PG.dialog.hooks).forEach((item) => {
      if (item && item.modal) {
        item.modal("hide");
      }
    });
  };
  /**
   * An object containing two predefined icon sets (using Font Awesome and the Glyphicons included in Bootstrap3),
   * as well as a string defining which set to use and a getter for returning the requested icon from the current set.
   *
   * @type {object}
   * @memberOf pg
   * @property {string} currentset - a string found in pg.config.webapp.iconSet.
   * @property {object} fontawesome - HTML (strings with classes) to render Font Awesome icons
   * @property {object} glyphicons - HTML (strings with classes) to render Bootstrap3 glyphicons halflings
   * @property {function} get - returns an icon from the current set matching the passed key
   */
  static icon = {
    currentset: pg.config.webapp.iconSet
      ? pg.config.webapp.iconSet
      : "fontawesome",
    fontawesome: {
      default: '<i class="fa fa-question-circle"></i>',
      directory: '<i class="fa fa-folder"></i>',
      file: '<i class="fa fa-file-o"></i>',
      upload: '<i class="fa fa-upload"></i>',
      download: '<i class="fa fa-download"></i>',
      checkedbox: '<i class="fa fa-check-square-o"></i>',
      uncheckedbox: '<i class="fa fa-square-o"></i>',
      trash: '<i class="fa fa-trash-o"></i>',
      levelup: '<i class="fa fa-level-up"></i>',
      settings: '<i class="fa fa-gears"></i>',
      more: '<i class="fa fa-plus-square-o"></i>',
      less: '<i class="fa fa-minus-square-o"></i>',
      addqueue: '<i class="fa fa-arrow-circle-right"></i>',
      envelope: '<i class="fa fa-envelope"></i>',
      ok: '<i class="fa fa-check"></i>',
      remove: '<i class="fa fa-times"></i>',
      repeat: '<i class="fa fa-repeat"></i>',
      refresh: '<i class="fa fa-refresh"></i>',
      spinner: '<i class="fa fa-spinner fa-spin"></i>',
      home: '<i class="fa fa-home"></i>',
      desktop: '<i class="fa fa-desktop"></i>',
      documents: '<i class="fa fa-files-o"></i>',
      downloads: '<i class="fa fa-download"></i>',
    },
    /**
     * Returns requested icon markup as a string
     *
     * @memberOf pg.icon
     * @param {string} icon - a valid property (key) of the current icon set object. See
     * pg.icon.fontawesome or pg.icon.glyphicons for a sample list
     * @returns {string}
     */
    get: function (icon) {
      let set = PG.icon[PG.icon.currentset];
      let theicon = set[icon];
      return theicon;
    },
  };

  static initialization = () => {
    // allow icons to be defined in the configuration.js file (or elsewhere) with
    // an object named pg.config.webapp.customIcons
    if (typeof (pg?.config.customIcons !== "undefined")) {
      $.extend(PG.icon, pg.config.customIcons);
    }
  };

  // use of Port is deprecated by HTTP Launcher,
  // but logic not updated yet, and we need the param because a call still uses helpUrl.
  static baseUrl = (service, port, helpUrl) => {
    port = port || ta_launcher.getLocal("port");

    if (typeof service === "object") {
      let node = service;
      let key = node.connectionKey;

      if (key === "local") {
        service = "transferRev1";
      } else {
        // for now, the service is always transfer
        // the else block is reserved for future changes
        service = "transferRev1";
      }
    }

    // sanitize the service input as much as possible
    service = service.trim();
    let serviceArray = service.split("/");

    for (let en = 0; en < serviceArray.length; en++) {
      serviceArray[en] = encodeURIComponent(serviceArray[en]);
    }

    service = serviceArray.join("/");
    console.log(`computed service is ${service}`);
    let filesUrls = [
      "local",
      "remote",
      "transferRev1",
      "transferRev1/cancel",
      "local/filter",
    ];
    let agentUrls = [
      "config",
      "heartbeat",
      "status",
      "version",
      "connect",
      "reveal",
      "register",
      "serviceStatus",
    ];

    if ($.inArray(service, filesUrls) >= 0) {
      service = "files/" + service;
    } else if ($.inArray(service, agentUrls) >= 0) {
      service = "agent/" + service;
    }

    let url = ta_launcher.basePath;
    console.log(`Base path from ta_launcher is ${url}`);
    try {
      //for central use -> protocol + ip + + ":" + port + "/rs/nodes/" + nodeID + "/ta"
      if (parseInt(PG.centralNewHost.nodeID) > 0) {
        url =
          centralNewHost.protocol +
          centralNewHost.ip +
          ":" +
          centralNewHost.port +
          "/rs/nodes/" +
          centralNewHost.nodeID +
          "/ta/";
      }
    } catch (e) {
      console.log(e);
      console.trace(e);
    }

    if (helpUrl !== undefined) {
      // Check again because I cannot change the core function without change other kind of use of TA deployment
      // - Dirceu Nazareth
      if (parseInt(PG.centralNewHost.nodeID) > 0) {
        return url;
      } else {
        return url + "/";
      }
    }

    if (typeof service !== "undefined" && PG.centralNewHost.nodeID === 0) {
      url += "/rs/" + service;
    } else {
      url += service;
    }
    return url;
  };

  static getVersionAjax = (successHandler, errorHandler) => {
    let data = { requester: "TransferAgent Deployment " + PG.version };
    let url = PG.baseUrl("version");
    $.ajax({
      url: url,
      type: "GET",
      async: true,
      data: data,
      success: function (data) {
        successHandler(data);
      },
      error: function (xhr, opts, error) {
        if (typeof errorHandler === "undefined") {
          console.error(error);
        } else {
          errorHandler(xhr, opts, error);
        }
      },
      statusCode: {
        0: function (xhr) {
          // override default status code 0 behaviour
        },
      },
    });
  };
}

PG.initialization();
